import React from 'react';
import PropTypes from 'prop-types';

import ErrorContext from '../../utilities/errorContext';
import { addNewRelicError, setNewRelicAttribute } from '../../utilities/newRelic';

class ErrorBoundary extends React.Component {
    constructor(props: any) {
        super(props);
        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error: any) {
        addNewRelicError(error, { clientTimestamp: Date.now(), sawError: true });
        setNewRelicAttribute('sawErrorPage', 'true');
        this.setState({ hasError: true });
    }

    render() {
        // @ts-expect-error TS2339: Property 'hasError' does not exist on type 'Readonly<>'.
        const { hasError } = this.state;
        // @ts-expect-error TS2339: Property 'renderOnError' does not exist on type 'Readonly<>'.
        const { renderOnError, children } = this.props;

        if (hasError) {
            return renderOnError;
        }

        return (
            <ErrorContext.Provider
                value={{
                    setError: () => {
                        this.setState({ hasError: true });
                    }
                }}
            >
                {children}
            </ErrorContext.Provider>
        );
    }
}

ErrorBoundary.propTypes = {
    renderOnError: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired
};

export default ErrorBoundary;
